export function GspWidgetManifest(name, deps) {
    return (constructor) => {
        GspWidgetManifest.prototype.registry[name] = {
            ctor: constructor,
            deps: deps || []
        };
    };
}

GspWidgetManifest.prototype.registry = {};

GspWidgetManifest.prototype.getProviders = function () {
    var registry = this.registry;
    return Object.keys(registry).map(function (key) {
        return {
            provide: key,
            useClass: registry[key].ctor,
            deps: registry[key].deps
        };
    });
};

GspWidgetManifest.prototype.getWidgetType = function (name) {
    return this.registry[name].ctor;
}